import SEO from "../components/SEO";
import Reveal from "../components/Reveal";
import FinalCTA from "../sections/FinalCTA";

export default function About() {
  return (
    <>
      <SEO
        title="About"
        description="ClientDesk VA is a business workspace made specifically for virtual assistants and independent service professionals."
        path="/about"
      />
      <section className="pt-20 pb-16 bg-[#FAF7F2]">
        <div className="max-w-3xl mx-auto px-5 sm:px-8">
          <Reveal>
            <div className="text-[13px] font-semibold uppercase tracking-[0.14em] text-[#E8712C] mb-3">
              About
            </div>
            <h1 className="font-display font-extrabold text-[36px] sm:text-[52px] leading-[1.05] tracking-[-0.03em] text-[#1A2A3A] mb-6">
              Made for people who serve clients.
            </h1>
            <p className="text-[17px] text-[#57534E] leading-relaxed mb-6">
              Virtual assistants and independent service professionals were
              running their businesses with six half-good tools stitched
              together with email. That's the problem ClientDesk VA was built
              to solve.
            </p>
            <p className="text-[17px] text-[#57534E] leading-relaxed mb-6">
              We didn't want to bolt "VA features" onto a sales CRM. We started
              from the client relationship — intake, bookings, tasks,
              documents, invoicing, follow-up — and built the software around
              how that day actually unfolds.
            </p>
            <p className="text-[17px] text-[#57534E] leading-relaxed">
              We say only the things we can prove. If we can't ship it, we
              don't advertise it. If it's not on the pricing page, it's not
              hiding in a fine-print upsell.
            </p>
          </Reveal>
        </div>
      </section>
      <FinalCTA />
    </>
  );
}
